import { AccommodationBooking } from '@/renderer/types/accommodation';
import { formatShortDate } from '@lib/utils';
import { setSelectedBooking } from '@store/accommodation';
import React from 'react';
import { useAppDispatch } from '../../../hooks/useRedux';
import { BookingStatusBadge } from './bookings/BookingStatusBadge';

interface Props {
  bookings: AccommodationBooking[];
  isLoading: boolean;
}

export const RecentArrivals: React.FC<Props> = ({ bookings, isLoading }) => {
  const dispatch = useAppDispatch();

  return (
    <div className="flex flex-col rounded-2xl border border-gray-200 bg-white">
      <div className="border-b border-gray-100 px-4 py-3">
        <h4 className="text-sm font-semibold text-gray-900">
          Upcoming &amp; Recent
        </h4>
      </div>

      {isLoading && bookings.length === 0 ? (
        <div className="flex flex-1 items-center justify-center py-8 text-xs text-gray-400">
          Loading…
        </div>
      ) : bookings.length === 0 ? (
        <div className="flex flex-1 items-center justify-center py-8 text-xs text-gray-400">
          No upcoming bookings
        </div>
      ) : (
        <div className="divide-y divide-gray-50">
          {bookings.map((b) => {
            const name = b.client
              ? `${b.client.first_name} ${b.client.last_name}`
              : '—';
            const rooms = b.booking_rooms ?? [];
            const roomNo = rooms[0]?.room?.room_number
              ? `#${rooms[0].room.room_number}`
              : '—';
            return (
              <button
                key={b.id}
                type="button"
                onClick={() => dispatch(setSelectedBooking(b))}
                className="flex w-full items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50"
              >
                <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-pos-primary/10 text-[10px] font-bold text-pos-primary">
                  {name[0] ?? '?'}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-xs font-medium text-gray-900">
                    {name}
                  </p>
                  <p className="text-[10px] text-gray-400">
                    {roomNo} · {formatShortDate(b.check_in)}
                  </p>
                </div>
                <BookingStatusBadge status={b.status} />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
